module.exports = __webpack_public_path__ + "img/whats2.86138162.png";